import styled, { css } from "styled-components";
import { AppBar } from "@mui/material";

const AppBarStyled = styled(AppBar)`
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  font-size: 16px;
  background-color: white !important;

  ${(props) =>
    props.zDepth !== 0 &&
    css`
      border-width: 1px;
      border-bottom-style: solid;
      border-bottom-color: #ffe500;
    `}

  svg {
    // color: #a826ee !important;
    // fill: #a826ee !important;
  }
`;

export default AppBarStyled;
